<template>

  <div v-if="links.length > 3" class="mt-6">
    <div class="flex justify-center text-teal-800">
        <template v-for="(link, key) in links">

            <div v-if="link.url === null"
                :key="key"
                class="mr-1 mb-1 px-4 py-3 text-sm border rounded text-gray-500"
                >
                {{ link.label }}
            </div>

            <inertia-link v-else :key="key"
                class="mr-1 mb-1 px-4 py-3 text-sm border rounded hover:border-teal-600 focus:border-teal-600 focus:text-teal-600 bg-white"
                :class="link.active ? 'bg-white border border-teal-600' : ''"
                :href="link.url">{{ link.label }}
            </inertia-link>

        </template>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    links: Array,
  },
}
</script>
